import { useDispatch, useSelector } from 'react-redux';
import { Box, Select, MenuItem, FormControl, Switch } from '@mui/material'
import { useEffect, useState } from 'react';
import { deepCopy, in_array, getExtraYearsList } from '../../../../app/util';
import dataService from '../../../../services/data.service';
import { sendLog } from '../../../../app/log-interface';
import moment from 'moment';
import { APP_CACHE } from "../../../../app//config";
//import DayDateToggle from './DayDateToggle';


const SdYears = () => {
    const controls = useSelector(state => state.app.current_state.app_state.workspace_controls);
    const app = useSelector(
        (state) => state.app
    );
    const { app_state, ui_state } = app.current_state

    const { profile } = useSelector((state) => state.auth);
    const{current_property_date} = profile;

    let [sdYear, setSdYear] = useState(null);
    const app_date_from = (["hotel_summary", "market_summary"].includes(ui_state.active_tiles[0])) ? app_state.summary_stay_range.date_from : app_state.primary_stay_range.date_from;    
    let {extraYears, extraYearsStart} = getExtraYearsList(app_date_from, controls.propertyYears[0], current_property_date);
    
    let [yearsList, setYearsList] = useState(controls.sdYearsArr || []);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        controls.sdlyOn = false;
        let value = e.target.value;
        if (sdYear !== value) {

            if (value && value !== sdYear) {
                setSdYear(value);
                let type = "sdyear";
                const updateTypes = [type];
                controls.sdYear = value;
                controls.sdlyOn = true;
                APP_CACHE.controls.sdlyOn = true;
                APP_CACHE.controls.sdYear = value;
                dispatch({
                    type: 'UPDATE_STATE',
                    payload: {
                        app_state: {
                            date_range_type: 'rangeTileChange_sdYear' + value,
                            workspace_controls: controls,
                            data_load: false
                        },
                        ui_state: { showspinner: true }
                    }
                })
            }
            if (!value) {
                setSdYear(null);
                let type = "sdyear";
                const updateTypes = [type];
                controls.sdYear = moment(app_state.primary_stay_range.date_from).subtract(1,'years').format('YYYY');
                controls.sdlyOn = false;
                APP_CACHE.controls.sdlyOn = false;
                APP_CACHE.controls.sdYear = controls.sdYear;
                dispatch({
                    type: 'UPDATE_STATE',
                    payload: {
                        app_state: {
                            date_range_type: 'rangeTileChange_sdYear' + value,
                            workspace_controls: controls,
                            data_load: false
                        },
                        ui_state: { showspinner: true }
                    }
                })
            }
            window.analyze.track("tile_change", {
                "selected_tile": ui_state.active_tiles.join(),
                compare_with: value || null,
            });
            sendLog({ category: "workspace_controls", action: "change_Compare_asOf" }, { ...app.current_state }, {
                app_state: { workspace_controls: controls, data_load: true },
                ui_state: { showspinner: true }
            })
        }
    }

    useEffect(() => {

        if(app_state.data_load){
            return;
        }
        const segmentType = app_state.workspace_controls.segmentType;
        let nullControlSDYear = moment(app_state.primary_stay_range.date_from).subtract(1,'years').format('YYYY');
        if(in_array(ui_state.active_tiles, ['hotel_summary', 'market_summary'])){
            nullControlSDYear = moment(app_state.summary_stay_range.date_from).subtract(1,'years').format('YYYY');
        }
        setSdYear(controls.sdYear);
        setYearsList(controls.sdYearsArr || []);
        
        if (controls.sdlyOn) {
            if (controls.sdYear > extraYearsStart) {
                setSdYear(extraYearsStart);
                controls.sdYear = extraYearsStart;
            } 
        }else{
            setSdYear(null);
        }

        let propertyDetails = deepCopy(dataService.getSeriesById("GetPropData").data);
        if (propertyDetails && propertyDetails.years) {
            let {extraYears} = getExtraYearsList(app_date_from, controls.propertyYears[0], current_property_date);
            let sdYearsArr = [null, ...extraYears, ...propertyDetails.years];
            let rt_years = [ ...extraYears, ...propertyDetails["rt-years"]];
            let rp_years = [...extraYears, ...propertyDetails["rp-years"]];

            controls.propertyYears = [...propertyDetails.years];
            controls.sdYearsArr = (sdYearsArr.length > 0) ? sdYearsArr : controls.sdYearsArr;
            controls.rt_years = (rt_years.length > 0) ? rt_years : [...sdYearsArr];
            controls.rp_years = (rp_years.length > 0) ? rp_years : [...sdYearsArr];

            if (ui_state.active_tiles[0] === "otb_v2_multi_segment" && segmentType === "rate_plan"){
                controls.sdYearsArr = [...controls.rp_years];
            }
            if (ui_state.active_tiles[0] === "otb_v2_multi_segment" && segmentType === "room_type") {
                controls.sdYearsArr = controls.rt_years;
            }


            setYearsList([...controls.sdYearsArr]);
            if(!in_array(ui_state.active_tiles, ['market', 'market_summary'])){
                if (!controls.sdYearsArr.includes(controls.sdYear ) ) {
                    controls.sdlyOn = false;
                    setSdYear(null);
                }
            }
        }
        else{

            if (!in_array(ui_state.active_tiles, ['market', 'market_summary'])){
                controls.sdYearsArr = [null, ...extraYears, ...controls.propertyYears];

                if (ui_state.active_tiles[0] === "otb_v2_multi_segment" && segmentType === "rate_plan"){
                    controls.sdYearsArr = [...controls.rp_years];
                }
                if (ui_state.active_tiles[0] === "otb_v2_multi_segment" && segmentType === "room_type") {
                    controls.sdYearsArr = controls.rt_years;
                }

                setYearsList([...controls.sdYearsArr]);
                if (!controls.sdYearsArr .includes(controls.sdYear) ) {
                    controls.sdlyOn = false;
                    setSdYear(null);
                }
            }
        }

        if (in_array(ui_state.active_tiles, ['market', 'market_summary']) && app_state.selected_market) {
            let marketSdYears = [];
            let allYears = [];
            let sdYearsArr = [...app_state.workspace_controls.sdYearsArr];
            const selected_market = app_state.selected_market;

            if (ui_state.active_tiles.length === 1) {
                marketSdYears = selected_market.year ? selected_market.year : controls.sdYearsArr;
                sdYearsArr = marketSdYears[0] ? [null, ...extraYears, ...marketSdYears] : marketSdYears;
            } else {
                // Merged view: allow the market's years, as the dropdown lists them (LRV-1068 below). Limiting to years the
                // property also has reset a listed year (e.g. 2025 for a hotel without SDLY) back to '---' after the load,
                // leaving the grid on rows cached for '---' under that year's columns. Tiles without that year show zeros.
                allYears = (selected_market && selected_market.year) ? selected_market.year : controls.sdYearsArr;
                sdYearsArr = [null, ...extraYears, ...allYears.filter(item => item)];
            }

            controls.sdYearsArr  = [...sdYearsArr];

            setYearsList([...controls.sdYearsArr]);
            if (!sdYearsArr.includes(controls.sdYear) ) {
                controls.sdlyOn = false;
                setSdYear(null);
            }


        }

        controls.sdYear = (controls.sdlyOn) ? controls.sdYear : nullControlSDYear;
        APP_CACHE.controls.sdlyOn = controls.sdlyOn;
        APP_CACHE.controls.sdYear = controls.sdYear;
        APP_CACHE.controls.sdYearsArr = controls.sdYearsArr;
        APP_CACHE.controls.rt_years = controls.rt_years;
        APP_CACHE.controls.rp_years = controls.rp_years;
        APP_CACHE.controls.propertyYears = controls.propertyYears;

        dispatch({
            type: 'UPDATE_STATE',
            payload: {
                app_state: {
                    workspace_controls: { ...controls },
                }
            }
        })
    }, [app_state.data_load, app_state.property_id, ui_state.active_tiles.join('_'), app_state.primary_stay_range.date_from, app_state?.summary_stay_range?.date_from, app_state.workspace_controls.segmentType, app_state?.selected_market?.market_id]);

    let segmentType = app_state.workspace_controls.segmentType;

    /** LRV-1068 , update sd year list on the basis of selected market */

    if (in_array(ui_state.active_tiles, ["market", "market_summary"]) && app_state.selected_market && app_state.selected_market.market_id) {
        let marketId = app_state.selected_market.market_id;
        const years = app_state.market_settings.find(item => item.market_id === marketId)?.year;
        let {extraYears} = getExtraYearsList(app_date_from, years[0], current_property_date);
        yearsList = [...extraYears, ...years];
    }

    if (ui_state.active_tiles[0] === "otb_v2_multi_segment" && segmentType === "rate_plan") {
        const years = (controls.rp_years.length > 1) ? controls.rp_years : controls.rp_years.splice(0, 0, null);
        let {extraYears} = getExtraYearsList(app_date_from, years[0], current_property_date);
        yearsList = [...extraYears, ...years];
    } else if (ui_state.active_tiles[0] === "otb_v2_multi_segment" && segmentType === "room_type") {
        const years = (controls.rt_years.length > 1) ? controls.rt_years : controls.rt_years.splice(0, 0, null);
        let {extraYears} = getExtraYearsList(app_date_from, years[0], current_property_date);
        yearsList = [...extraYears, ...years];
    }    

    return (
        <>
            <Box id="sdyearBox" sx={{ height: 1 / 2 }}>
                {/* LRV-880 (uncomment the below div) */}
                {/* <Box className="data-level-label"><DayDateToggle /></Box> */}
                <Box className="data-level-label">Compare with</Box>
                <FormControl size="small" sx={{ minWidth: "100%", borderRadius: "16px" }}>
                    <Select displayEmpty className='tabular-data-filter' value={sdYear} sx={{ height: "30px", minWidth: "70px", mt: "5px" }}
                        onChange={handleChange}>
                        <MenuItem value={null} className='tabular-data-filter'> --- </MenuItem>
                        {yearsList && yearsList.map((items, index) => {
                            if (items && items <= moment(app_date_from).subtract(1, 'years').format('YYYY')) {
                                return (<MenuItem value={items} className='tabular-data-filter'> {items} </MenuItem>)
                            }
                        })}

                    </Select>
                </FormControl>
            </Box>

        </>
    )
}


export default SdYears